/* eslint-disable no-unused-vars */
import React, { memo } from 'react';
import _ from 'lodash';

import CollapseableTree from '@components/collapseable-tree';
import CollapseableFilter from './task-status';
import style from './style.module.scss';
import Divider from '@components/divider';

const PipelineFilterGroups = ({
  isActive,
  treeData,
  filters,
  pipelinesAreaHierarchyTreeDataMap,
  updateFilters,
  pipelineStatusTags,
  picklistsMap
}) => {
  return (
    <>
      {/* <p
        className="label-regular op-filter-label"
        style={{ padding: '29px 0px 32px 0px', marginBottom: '0px' }}
      >
        Pipeline
      </p> */}

      <div className={style.filterHeader}>
        <p>Pipeline</p>
      </div>

      <div>
        {!_.isEmpty(pipelinesAreaHierarchyTreeDataMap) && (
          <>
            <div className={style.filterRowContainer}>
              <CollapseableTree
                header={'Pipeline area'}
                isActive={isActive}
                treeData={treeData}
                value={filters.pipelineArea.value}
                treeDataMap={pipelinesAreaHierarchyTreeDataMap}
                onChange={(value) => updateFilters('pipelineArea', 'value', value)}
              />
            </div>
            <Divider />
          </>
        )}
      </div>
      <div>
        {pipelineStatusTags?.length > 0 && (
          <>
            <div className={style.filterRowContainer}>
              <CollapseableFilter
                title={'Pipeline status'}
                tags={pipelineStatusTags || []}
                tagsMap={picklistsMap}
                multi
                value={filters?.pipelineStatus?.value}
                onChange={(value) => updateFilters('pipelineStatus', 'value', value)}
              />
            </div>
            <Divider />
          </>
        )}
      </div>
    </>
  );
};

export default memo(PipelineFilterGroups);
